/** Valor enviado en login solo desde el web Kardex; debe coincidir con el backend (`USER_TYPE_INTERNO_SDM`). */
export const USER_TYPE_INTERNO_SDM = 'InternoSDM';
